module.exports = __webpack_public_path__ + "img/notfound.05a611b7.png";